import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCollectionBanner } from "../../services/productService";
import "./CollectionBanner.css";

function CollectionBanner() {

    const navigate = useNavigate();

    const [banner, setBanner] = useState(null);

    useEffect(() => {
        loadBanner();
    }, []);

    const loadBanner = async () => {
        try {
            const response = await getCollectionBanner();
            setBanner(response.data);
            console.log('banner response'+response);
        } catch (error) {
            console.error(error);
        }
    };

    if (!banner) {
        return null;
    }

    return (
        <section className="collection-banner-section">
    <div className="collection-banner-wrapper">
        <div
            className="collection-banner-container"
            onClick={() => navigate("/collections")}
        >
            <img
                src={banner.collectionDetailImageUrl}
                alt={banner.collectionDetailTitle}
                className="collection-banner-image"
            />
        </div>
    </div>
</section>
    );
}

export default CollectionBanner;